import React, { useEffect, useMemo, useState } from "react";
import ClockIcon from "../../assets/cards/clock.svg";
import sethoscopeIcon from "../../assets/cards/maki_doctor.svg";
import calenderIcon from "../../assets/cards/uil_notes.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";
import Created from "../../assets/landingscreen/Pending.svg";
import CompletedIcon from "../../assets/landingscreen/CompletedIcon.svg";
import crossIcon from "../../assets/landingscreen/CloseIcon.svg";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Paymentsmodal from "../modals/payments";
import PersonalVideoIcon from "@mui/icons-material/PersonalVideo";
import cancelledDesk from "../../../src/assets/Signin/FrontCancel.svg";
import DropdownMenu from "../modals/menu";
import VisitStatusUpdate from "../modals/VisitStatusUpdate";
import ImagingModal from "../modals/imagingmodal";
import MeetingRoomOutlinedIcon from "@mui/icons-material/MeetingRoomOutlined";
import {
  alertIcon,
  ChartIcon,
  closeIcon,
  COMPLETEDIcon,
  CROSSIcon,
  listFileIcon,
  actionDollarIconbig,
  NotesIcon,
  OrderIcon,
  actionDropDownCalenderIconbig,
  actionDropDownChatIconBig,
  actionDropDownSchedulerIconBig,
  mobileicon,
  mobileapp,
  cancelfrontdeskicon,
  vitalsiconbig,
  intakeiconbig,
  RoomBadge,
  RpmIcon,
  mobileiconnew,
  cancelfrontdeskicondashboard,
  bluesethescope,
} from "../modals/svgs";
import { actionDropDownCalenderIcon, filterIcon } from "../modals/svgs";
import AssignRoomModal from "../modals/assignroommodal";
import VisitStatusModal from "../modals/visitstatusmodal";
import PurposeOfVisitModal from "../modals/purposeofvisitmodal";
import ProviderModal from "../modals/Providermodal";
import AddNotesModal from "../modals/notemodal";
import { faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import TasksModal from "../../tasks/Modals/TasksModal";
import { calendericonblue } from "../../utils/svgs/svgcode";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CCMIcon, RPMIcon } from "../landingsvgs";
import { pendingIcon } from "../../orders/tabs/svg";
import { set } from "date-fns";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { eventBus } from "../../utils/eventBus";
import ConfirmFrontdesk from "../../signin/popups/ConfirmFrontdesk";
import AllAppointmentsModal from "./allappointmentmodal";
import QualityRiskApptsModal from "../modals/QualityRiskApptsModal";

dayjs.extend(customParseFormat);
const ExpandedView = ({
  selectedCard,
  setFetchedData,
  setSelectedCard,
  fetchUpdateFrontDesk,
  rpmvalues,
  updateeyeicon,
  searchTerm,
  setChat,
  fetchedData,
  dob,
  modalopen,
  insertdata,
  paymentdetails,
  alldata,
  markAsComplete,
  markAscancel,
  handleconfirmScheduleClick,
  scheduleStates,
  setIsStatusNotesPopUp,
  setIsOrdersOverlay,
  fetchpcarddata,
  data,
  onUpdateVisitStatus,
  onUpdateRoom,
  setIsRoomNoOverlay,
  setToastSeverity,
  setToastMessage,
  setOpenToast,
  selectedOrder,
  setSelectedOrder,
  refreshDashboard,
  handleschedular,
}) => {
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [VisitStatus, setVisitStatus] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const homescreenprev = useSelector(
    (state) => state.userPrivileges.homescreen,
  );
  const location = useLocation();
  const fromPatientId = location.state?.fromPatientId;
  const [openAllApptsModal, setOpenAllApptsModal] = useState(false);
  const [showMore, setShowMore] = useState(false);

  const currentDate = useSelector((state) => state.filter.currentDate);

  const [isQuickOpen, setIsQuickOpen] = useState(false);
  const userConfig = useSelector((state) => state.userconfig);
  const [visitModalOpen, setVisitModalOpen] = useState(false);
  const [roomModalOpen, setRoomModalOpen] = useState(false);
  const [purposeModalOpen, setPurposeModalOpen] = useState(false);
  const [purposeInitialIndex, setPurposeInitialIndex] = useState(0);
  const [localPurpose, setLocalPurpose] = useState("");
  const [providerModalOpen, setProviderModalOpen] = useState(false);
  const [localProvider, setLocalProvider] = useState(
    data.linked_provider || "",
  );
  const [frontDesk, setFrontDesk] = useState("");
  const [frontdeskModal, setfrontdeskModal] = useState(false);
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] =
    useState(false);
  const [cachedPins, setCachedPins] = useState([]);
  console.log(data, "daaaa");
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [quartersModalOpen, setQuartersModalOpen] = useState(false);
  const [noteDraft, setNoteDraft] = useState({
    assignee: "Provider",
    message: "",
  });
  const [totalOrders, setTotalOrders] = useState([]);
  const percentage = 100; // Set your percentage value here
  const navigate = useNavigate();
  // Styles for the circular progress bar and small circle with percentage text
  const circleStyle = {
    background: `conic-gradient(#50869A ${percentage * 3.6}deg, #EDEDED ${
      percentage * 3.6
    }deg)`,
  };
  // const reduxDate = useSelector((state) => state.filter.currentDate);
  // // const startDateObj = new Date(data.startdate);
  // const startDateObj = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss");
  // console.log(data.startdate,'starttttt')
  // const dtObj = reduxDate;
  // const year = startDateObj.getFullYear();
  // const month = String(startDateObj.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  // const day = String(startDateObj.getDate()).padStart(2, "0");
  const viewMode = "tile";
  // const formattedDate = `${year}-${month}-${day}`;
  // const isSameDate = formattedDate === dtObj;
  const reduxDate = useSelector((state) => state.filter.currentDate);

  // start date from API
  const startDateObj = dayjs(data.startdate, "YYYY-MM-DD HH:mm:ss");

  // redux date (assume format YYYY-MM-DD)
  const dtObj = dayjs(reduxDate, "YYYY-MM-DD");

  // ✅ timezone-safe same day check
  const isSameDate = startDateObj.isSame(dtObj, "day");
  const angle = percentage * 3.6;
  const radians = (angle - 90) * (Math.PI / 180);
  const radius = 45; // Increased radius
  const smallCircleOffset = 10; // Adjusted offset for larger size
  const smallCircleStyle = {
    position: "absolute",
    top: `${50 + radius * Math.sin(radians) - smallCircleOffset}px`,
    left: `${56 + radius * Math.cos(radians) - smallCircleOffset}px`,
    width: "28px", // Increased size of the small circle
    height: "28px",
    backgroundColor: "#FFFFFF",
    borderRadius: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };
  const openNoteModal = () => setNoteModalOpen(true);

  const openPaymentModal = () => {
    setIsPaymentModalOpen(true); // Open the payment modal
  };

  // Function to close the Payment modal
  const closePaymentModal = () => {
    setIsPaymentModalOpen(false); // Close the payment modal
  };
  const GREEN = "58D68D";
  const RED = "F3082C";
  const YELLOW = "F9E79F";

  const newgreen = "#10B981";
  const newred = "#FF7E7E";
  const newyellow = "#F59E0B";
  const mapColor = (x) => {
    if (!x) return null;

    const value = String(x).replace("#", "").toUpperCase();

    if (value === GREEN) return newgreen;
    if (value === RED) return newred;
    if (value === YELLOW) return newyellow;

    return null;
  };
  const handleFrontDeskToggle = () => {
    const newStatus = frontDesk === "Y" ? "N" : "Y";
    setFrontDesk(newStatus);
    fetchUpdateFrontDesk({ frontDesk: newStatus, data: data });
  };
  const getPatientColor = () => {
    const raw = data?.deductiblemet;
    if (!raw) return "none";

    const color = String(raw).trim().replace("#", "").toUpperCase();

    if (color === GREEN) return "green";
    if (color === RED || color === YELLOW) return "red";

    return "none";
  };

  const isVitamin = (order) => order?.ordertype?.toLowerCase() === "vitamin";

  const shouldShowPrice = (order) => {
    const color = getPatientColor();

    if (color === "red") return true;

    if (color === "green") return isVitamin(order);

    return isVitamin(order);
  };
  const getSafeNumber = (value) => {
    const num = Number(value);
    return Number.isFinite(num) ? num : 0;
  };

  const deductibleAmt = getSafeNumber(data?.deductibleamt);
  const selfPay = getSafeNumber(data?.selfpay);
  const accountBalance = getSafeNumber(data?.acctbalance);
  const copayAmt = getSafeNumber(data?.copay);

  const latestRpm = useMemo(() => {
    if (!Array.isArray(rpmvalues)) return null;

    const patientRecords = rpmvalues
      .filter((r) => String(r.patientid) === String(data?.patientid))
      .sort((a, b) => new Date(b.datetime) - new Date(a.datetime));

    return patientRecords.length ? patientRecords[0] : null;
  }, [rpmvalues, data?.patientid]);

  const closeNoteModal = () => setNoteModalOpen(false);

  const closeVisitStatus = () => {
    setVisitStatus(false);
  };
  const formatTime = (time) => {
    if (!time) return "-";

    const [hourStr, minute] = time.split(":");
    let hour = Number(hourStr);

    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // convert 0 → 12

    return `${hour}:${minute} ${period}`;
  };
  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(true); // Open the confirmation modal
  };
  const getCoveredPlans = (data) => {
    try {
      console.log("Getting covered plans from data:", data?.appointment_specific);
      const raw = data?.appointment_specific?.insuranceCoveredPlan;
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  };
  const isOrderCovered = (orderName, coveredPlans = [], ordertype) => {
    console.log("1Checking coverage for order:", orderName, "Covered plans:", coveredPlans);
    if (!orderName) return false;

    const name = orderName.trim().toUpperCase();
    const type = ordertype.trim().toUpperCase();
console.log("2Checking coverage for order:", orderName, "Covered plans:", coveredPlans);
    if (type === "INJECTIONS") return coveredPlans.includes("Injections");
    if (name === "ECG/EKG") return coveredPlans.includes("EKG");
    if (name === "HOME SLEEP STUDY")
      return coveredPlans.includes("SLEEP STUDY");
    if (name === "ECHO") return coveredPlans.includes("ECHO");
    if (name.startsWith("US")) return coveredPlans.includes("ULTRASOUND");

    return coveredPlans.includes(name);
  };
  const calculateCostEstimate = () => {
    const orders = data?.orders || [];
    const coveredPlans = getCoveredPlans(data);
    const color = getPatientColor();

    // green → no estimate
    if (color === "green") return 0;

    let total = 0;

    orders.forEach((order) => {
      if (!shouldShowPrice(order)) return;

      const matched = paymentdetails.find(
        (p) => p.content === order?.ordername,
      );
      if (!matched) return;

      console.log("Calculating cost for orderTypes :", order?.ordertype, "Covered plans:", coveredPlans);
      const isCoveredType = coveredPlans.includes(order?.ordertype);
      if (isCoveredType) return;
      const isCovered = isOrderCovered(order?.ordername, coveredPlans, order?.ordertype);
      if (isCovered) return;

      const amount = isVitamin(order)
        ? Number(matched.selfpay_cost || 0)
        : Number(matched.insurance_cost || 0);

      total += amount;
    });

    return total;
  };

  // Map order code to the insurance plan
  function mapOrderCodeToPlan(orderName, coveredPlans) {
    const orderNameUpper = orderName.trim().toUpperCase();
console.log("Mapping order to plan → order:", orderNameUpper, "plans:", coveredPlans);
    if (orderNameUpper === "ECG/EKG" && coveredPlans.includes("EKG")) return true;
    if (orderNameUpper === "HOME SLEEP STUDY" && coveredPlans.includes("SLEEP STUDY")) return true;
    if (orderNameUpper === "ECHO" && coveredPlans.includes("ECHO")) return true;
    
    if (orderNameUpper.startsWith("US") && coveredPlans.includes("ULTRASOUND")) return true;
    
    return false;
  }

  const patientColor = getPatientColor();

  let costEstimate = 0;

  // 🟡 If yellow → take from percentage.Amount
  if (data?.deductiblemet?.toUpperCase() === YELLOW) {
    costEstimate = Number(data?.percentage?.Amount || 0);
  }
  // 🟢 green → 0
  else if (patientColor === "green") {
    costEstimate = 0;
  }
  // 🔴 red → existing calculation
  else {
    costEstimate = calculateCostEstimate();
  }

  // const finalCopayTotal =
  //   costEstimate +
  //   // deductibleAmt +
  //   selfPay +
  //   accountBalance+
  //+copayAmt

  // const totalDue = Number(costEstimate || 0) + Number(selfPay || 0);

  // const credits =
  //   Number(accountBalance || 0) +
  //   Number(copayAmt || 0) +
  //   Number(data?.paidamount || 0);

  // const finalCopayTotal = Math.max(0, totalDue - credits);
  const finalCopayTotal =
    costEstimate +
    // deductibleAmt +
    selfPay +
    accountBalance +
    copayAmt;
  const finalformattedTotalcopay =
    Number(finalCopayTotal) % 1 === 0
      ? Number(finalCopayTotal)
      : Number(finalCopayTotal).toFixed(2);

  //   console.log("Patient  data:4808", {
  //   finalformattedTotalcopay,
  //   costEstimate,
  //   selfPay,
  //   accountBalance,
  //   copayAmt,
  //   paidamou0nt: data?.paidamount
  // });
  //     useEffect(()=>{
  //     if (data?.patientid == 4808) {
  //   console.log("Patient  data:4808", {
  //     finalformattedTotalcopay,
  //     costEstimate,
  //     selfPay,
  //     accountBalance,
  //     copayAmt,
  //     paidamount: data?.paidamount
  //   });
  // }
  //     },[data,])

  const statusChipClasses = (label, active) => {
    // ✅ inactive → always default
    if (!active) return "bg-[#D1E1FF] text-[#004867]";

    if (label === "Ready for Triage") return "border-[#A7F3D0] text-[#065F46]";
    if (label === "Cancelled") return "border-[#FECACA] text-[#991B1B]";
    if (label === "In-Office - Confirmed")
      return "border-[#E9D5FF] text-[#581C87]";
    if (label === "Ready for Representative")
      return "border-[#FEF08A] text-[#854D0E]";
    if (label === "Processing") return "border-[#E2E8F0] text-[#1E293B]";
    if (label === "Walk-in") return "border-[#DDD6FE] text-[#4C1D95]";
    if (["Injections", "Labs"].includes(label))
      return "border-[#FED7AA] text-[#9A3412]";
    if (label === "Checked Out") return "border-[#FDA4AF] text-[#9F1239]";
    if (label === "Ready for Provider")
      return "border-[#FBCFE8] text-[#9D174D]";
    if (label === "Ready for Checkout")
      return "border-[#C7D2FE] text-[#312E81]";
    if (label === "Ready for Nurse") return "border-[#A5F3FC] text-[#155E75]";
    if (label === "No Show") return "border-[#D1D5DB] text-[#1F2937]";
    if (label === "Active") return "border-[#BBF7D0] text-[#166534]";
    if (label === "Rescheduled") return "border-[#BFDBFE] text-[#1E40AF]";

    // ✅ ANY NOT MATCH → default
    return "bg-[#D1E1FF] text-[#004867]";
  };

  const CardBox = ({ data, paymentdetails }) => {
    const orders = data.orders || [];

    const completedOrCancelled = ["COMPLETED", "CANCELLEDTASK"];

    const allInactive =
      orders.length > 0 &&
      orders.every((order) =>
        completedOrCancelled.includes(String(order?.status).toUpperCase()),
      );

    // Count active orders only (non-completed/cancelled)
    const activeOrders = orders.filter(
      (order) =>
        !completedOrCancelled.includes(String(order?.status).toUpperCase()),
    );

    const activeCount = activeOrders.reduce((acc, order) => {
      const rawType = (order?.ordertype || "").trim();
      const isVisit = rawType.toUpperCase() === "VISIT";
      if (!isVisit) return acc + 1;
      let c = 0;
      if (order?.tov) c += 1;
      if (order?.tov2) c += 1;
      return acc + c;
    }, 0);

    // Count all (for when all are inactive)
    const totalCount = orders.reduce((acc, order) => {
      const rawType = (order?.ordertype || "").trim();
      const isVisit = rawType.toUpperCase() === "VISIT";
      if (!isVisit) return acc + 1;
      let c = 0;
      if (order?.tov) c += 1;
      if (order?.tov2) c += 1;
      return acc + c;
    }, 0);

    // Decide what to show
    const listedCount = allInactive ? totalCount : activeCount;

    return (
      <button
        className="w-full h-full  items-start focus:outline-none focus:ring-0   focus:ring-offset-0 focus-visible:outline-none"
        onClick={() => {
          if (!orders.length) return;
          setTotalOrders(orders);
          setIsQuickOpen(true);
        }}
      >
        <div className="flex items-center gap-2 mb-1">
          <span className="text-[#6B7280] font-[600] font-inter text-[14px]">
            Orders / Tasks
          </span>
          <span
            className={`inline-flex items-center justify-center h-6 w-6 rounded-full text-[12px] font-semibold ${
              allInactive
                ? "bg-[#E5E7EB] text-[#6B7280]"
                : listedCount > 0
                  ? "bg-[#DF6F46] text-white"
                  : "bg-[#E5E7EB] text-[#6B7280]"
            }`}
          >
            {listedCount}
          </span>
        </div>
        <div className="h-[240px] pr-3 overflow-y-auto card_custom-scrollbar">
          {orders.length === 0 ? (
            <div className="flex flex-col justify-center items-center h-full text-center py-8">
              <div className="mb-3">{listFileIcon}</div>

              <p className="text-[#6B7280] text-sm font-medium font-inter mb-1">
                No orders yet
              </p>

              <p className="text-[#9CA3AF] text-xs font-normal font-inter">
                Orders will appear here when added
              </p>
            </div>
          ) : (
            <div className="flex flex-col">
              {/* <span className="mb-1 text-xs font-semibold text-left text-[#364153] uppercase">
                Visit Details
              </span> */}

              {[...orders]
                .filter((order) => {
                  const status = String(order?.status).toUpperCase();
                  if (status === "CANCELLEDTASK" && order?.is_hide === "Y") {
                    return false; // don't show
                  }
                  return true;
                })
                .sort((a, b) => {
                  const getOrderRank = (status) => {
                    const s = String(status).toUpperCase();
                    if (s === "COMPLETED") return 2; // middle
                    if (s === "PENDING" || s === "CANCELLEDTASK") return 3; // last
                    return 1; // normal first
                  };
                  return getOrderRank(a.status) - getOrderRank(b.status);
                })
                .map((order) => {
                  const rawType = (order?.ordertype || "").trim();
                  const isVisit = rawType.toUpperCase() === "VISIT";
                  const isNotes = rawType.toLowerCase() === "notes";

                  const typeLabel =
                    rawType.charAt(0).toUpperCase() +
                    rawType.slice(1).toLowerCase();

                  const name = order?.ordername || "-";
                  const MAX_CHARS = 35;
                  const clipped =
                    name.length > MAX_CHARS
                      ? `${name.slice(0, MAX_CHARS)}…`
                      : name;

                  const renderRow = (label, value, key) => (
                    <>
                      <div
                        key={order.id}
                        className={`my-1 py-[12px] px-3 flex rounded-xl shadow-sm transition-all
    ${
      String(order?.status).toUpperCase() === "COMPLETED" &&
      userConfig?.config?.tasks_completed
        ? "border-[1px] border-[#DCFCE7] shadow-[#0000000D] bg-white opacity-[60%]"
        : String(order?.status).toUpperCase() === "CANCELLEDTASK" &&
            userConfig?.config?.tasks_completed
          ? "border-[1px] border-[#FECACA] shadow-[#0000000D] bg-white opacity-[60%]"
          : "border-[1px] border-[#F1F5F9] shadow-[#0000000D] bg-white opacity-[100%]"
    }`}
                      >
                        {/* Left icon */}
                        {/* {["COMPLETED", "CANCELLEDTASK"].includes(
                          String(order?.status).toUpperCase()
                        ) && ( */}
                        <div className="mr-1 flex items-center w-[7%]">
                          {String(order?.status).toUpperCase() === "COMPLETED"
                            ? COMPLETEDIcon
                            : String(order?.status).toUpperCase() ===
                                "CANCELLEDTASK"
                              ? CROSSIcon
                              : pendingIcon}
                        </div>
                        {/* 
                         )} */}

                        {/* Middle text */}
                        <div className="gap-1 text-left flex flex-col w-[95%]">
                          <div>
                          <span
                            className={`font-[600] font-inter text-xs uppercase tracking-wide ${
                              (String(order?.status).toUpperCase() ===
                                "COMPLETED" ||
                                String(order?.status).toUpperCase() ===
                                  "CANCELLEDTASK") &&
                              userConfig?.config?.tasks_completed
                                ? "text-[#9CA3AF]"
                                : "text-[#6B7280]"
                            }`}
                          >
                            {isNotes && label && <span>{label}</span>}
                            {isNotes && order?.user_role && (
                              <span>&nbsp;{order.user_role}</span>
                            )}
                            </span>

                            <span className={`inline-block p-1 rounded-full text-[10px] ${
                                order?.schedule === 't'
                                  ? 'bg-[#E17954] text-white'
                                  : 'bg-[#13b981] text-white'
                              } hover:opacity-90 transition`}
                            >
                              {order?.schedule === 't' ? 'Schedule' : 'Today'}
                            </span>                          
                          </div>
                          <span
                            className={`font-inter font-semibold text-[15px] text-left ${
                              (String(order?.status).toUpperCase() ===
                                "COMPLETED" ||
                                String(order?.status).toUpperCase() ===
                                  "CANCELLEDTASK") &&
                              userConfig?.config?.tasks_completed
                                ? "text-[#6B7280]"
                                : "text-[#111827]"
                            }`}
                            title={value}
                          >
                            {value || "-"}
                          </span>
                        </div>

                        {/* Right price */}
                        <div className="flex items-center w-[5%] justify-end">
                          {/* {(() => {
                            const matchedPatient = paymentdetails.find(
                              (p) => p.content === order?.ordername,
                            );

                            if (!matchedPatient) return null;
                            if (!shouldShowPrice(order)) return null;
                            if (!userConfig.config?.show_prices) return null;

                            const price = isVitamin(order)
                              ? matchedPatient.selfpay_cost
                              : matchedPatient.insurance_cost;

                            return (
                              <span className="text-[19px] font-inter font-bold text-[#F97316]">
                                ${price}
                              </span>
                            );
                          })()} */}

                          

                          {(() => {
                            const matchedPatient = paymentdetails.find(
                              (p) => p.content === order?.ordername
                            );

                            if (
                              !matchedPatient ||
                              !shouldShowPrice(order) ||
                              !userConfig?.config?.show_prices
                            ) {
                              return null;
                            }

                            // ✅ FIX 1: use data instead of order
                            const insCoveredPlan = getCoveredPlans(data) || [];

                            // normalize plans once
                            const normalizedPlans = insCoveredPlan.map((p) =>
                              String(p).toUpperCase()
                            );

                            const orderType = String(order?.ordertype || "").toUpperCase();
                            const orderName = order?.ordername;

                            // ✅ Vitamin → always self pay
                            if (orderType === "VITAMIN") {
                              return (
                                <span className="text-[19px] font-inter font-bold text-[#F97316]">
                                  ${Math.floor(matchedPatient.selfpay_cost || 0)}
                                </span>
                              );
                            }

                            // ✅ FIX 2: use data.deductiblemet
                            const deductible = String(data?.deductiblemet || "").toUpperCase();

                            // 🟡 YELLOW → insurance cost
                            if (deductible === "F9E79F" && matchedPatient.insurance_cost > 0) {
                              return (
                                <span className="text-[19px] font-inter font-bold text-[#F97316]">
                                  ${Math.floor(matchedPatient.insurance_cost)}
                                </span>
                              );
                            }

                            // 🔴 RED → check coverage
                            if (deductible === "F3082C" && matchedPatient.selfpay_cost > 0) {
                              const isCovered =
                                mapOrderCodeToPlan(orderName, normalizedPlans) ||
                                normalizedPlans.includes(orderType);

                              if (isCovered) return null; // cleaner than <span />

                              return (
                                <span className="text-[19px] font-inter font-bold text-[#F97316]">
                                  ${Math.floor(matchedPatient.selfpay_cost)}
                                </span>
                              );
                            }

                            // ✅ Default
                            const price =
                              orderType === "VITAMIN"
                                ? matchedPatient.selfpay_cost
                                : matchedPatient.insurance_cost;

                            return (
                              <span className="text-[19px] font-inter font-bold text-[#F97316]">
                                ${Math.floor(price || 0)}
                              </span>
                            );
                          })()}


                          {String(order?.status).toUpperCase() ===
                            "CANCELLEDTASK" &&
                            String(order?.is_hide).toUpperCase() === "N" && (
                              <FontAwesomeIcon
                                icon={faEyeSlash}
                                className="text-[#9CA3AF] text-[14px] cursor-pointer"
                                title="Hidden order"
                                onClick={(e) => {
                                  e.stopPropagation(); // 🚨 prevents quick modal
                                  updateeyeicon(order);
                                  console.log(
                                    "Eye icon clicked → order:",
                                    order,
                                  );
                                }}
                              />
                            )}
                        </div>
                      </div>
                    </>
                  );

                  // For non-VISIT → show normal row
                  if (!isVisit) {
                    return renderRow(typeLabel, clipped, order.id);
                  }

                  // For VISIT → show row(s) only if that value exists
                  return (
                    <React.Fragment key={order.id}>
                      {order?.tov &&
                        renderRow("Visit", order.tov, `${order.id}-tov`)}
                      {order?.tov2 &&
                        renderRow("Visit", order.tov2, `${order.id}-tov2`)}
                    </React.Fragment>
                  );
                })}
            </div>
          )}
        </div>
      </button>
    );
  };

  const allActions = [
    {
      id: 1,
      key: "Chart",
      icon: ChartIcon,
      label: "Charts",
      onClick: () => modalopen(data.id),
      visible: homescreenprev.includes("Chart"),
    },
    {
      id: 2,
      key: "Order",
      icon: OrderIcon,
      label: "Orders",
      onClick: () => {
        if (!isSameDate) {
          setToastMessage("Please schedule an appointment");
          setToastSeverity("info");
          setOpenToast(true);
          return;
        }
        navigate(
          `/orders/${data.appointmentid}/${data.startdate}/${searchTerm || fromPatientId ? "filter" : "all"}`,
        );
      },
      visible: homescreenprev.includes("Order"),
    },
    {
      id: 3,
      key: "Notes",
      icon: NotesIcon,
      label: "Notes",
      onClick: openNoteModal,
      visible: homescreenprev.includes("Notes"),
    },
    {
      id: 4,
      key: "Take Payment",
      icon: actionDollarIconbig,
      label: "Payments",
      onClick: openPaymentModal,
      visible: homescreenprev.includes("Take Payment"),
    },
    {
      id: 5,
      key: "Imaging",
      icon: actionDropDownCalenderIconbig,
      label: "Imaging",
      onClick: () => insertdata(data),
      visible: true,
    },
    {
      id: 6,
      key: "Chat",
      icon: actionDropDownChatIconBig,
      label: "Chat",
      onClick: () => {
        setSelectedCard(data);
        setChat(true);
      },
      visible: true,
    },
    {
      id: 7,
      key: "Scheduler",
      icon: actionDropDownSchedulerIconBig,
      label: "Scheduler",
      onClick: () => {
        setSelectedCard(data);
        handleschedular(data);
      },
      visible: true,
    },
    {
      id: 8,
      key: "Vitals",
      icon: vitalsiconbig,
      label: "Vitals",
      onClick: () => {
        modalopen(data.id);

        setTimeout(() => {
          eventBus.emit("navigateToPriorVitals", { tab: 3, internalTab: 1 });
        }, 50); // or 100ms if needed
      },
      visible: true,
    },
    {
      id: 9,
      key: "Intake",
      icon: intakeiconbig,
      label: "Intake",
      onClick: () => {
        modalopen(data.id);

        setTimeout(() => {
          eventBus.emit("navigateToPriorVitals", { tab: 3, internalTab: 0 });
        }, 50); // or 100ms if needed
      },
      visible: homescreenprev.includes("Intake"),
    },
  ];
  const latestAppointment = (() => {
    if (!Array.isArray(data?.allappts)) return null;

    const grouped = {};

    data.allappts.forEach((appt) => {
      const date = dayjs(appt.startdate).format("YYYY-MM-DD");

      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(appt);
    });

    const result = Object.values(grouped).map((appointments) => {
      const valid = appointments.filter(
        (a) => a.visit_confirmation !== "Cancelled",
      );

      const list = valid.length ? valid : appointments;

      return list.sort(
        (a, b) => new Date(b.startdate) - new Date(a.startdate),
      )[0];
    });

    return result[0] || null; // 👈 THIS LINE
  })();

  useEffect(() => {
    if (
      Array.isArray(userConfig?.config?.dash_pins) &&
      userConfig.config.dash_pins.length
    ) {
      setCachedPins(userConfig.config.dash_pins);
    }
  }, [userConfig?.config?.dash_pins]);

  const pinnedActions = useMemo(() => {
    const pins = userConfig?.config?.dash_pins;

    const activePins = Array.isArray(pins) && pins.length ? pins : cachedPins;

    if (!activePins || !activePins.length) return [];

    return activePins
      .map((id) => allActions.find((act) => act.id === id))
      .filter(Boolean)
      .reverse();
  }, [userConfig?.config?.dash_pins, cachedPins, homescreenprev]);
  const allAppts = Array.isArray(data?.allappts) ? data.allappts : [];
  const MAX_VISIBLE = 2;
  const visibleAppts = allAppts.slice(0, MAX_VISIBLE);
  const visibleAppt = allAppts;
  const remainingCount = Math.max(allAppts.length - MAX_VISIBLE, 0);
  const cardHeight = useMemo(() => {
    const BASE_HEIGHT = 320;
    const ACTION_HEIGHT = 65;
    const MAX_VISIBLE = 3;

    const extraPinned =
      pinnedActions.length > MAX_VISIBLE
        ? pinnedActions.length - MAX_VISIBLE
        : 0;
    const cancelledExtra =
      latestAppointment?.visit_confirmation === "Cancelled" ? 5 : 0;
    return BASE_HEIGHT + extraPinned * ACTION_HEIGHT + cancelledExtra;
  }, [pinnedActions]);

  return (
    <>
      <div
        style={{
          height: "auto",
        }}
        className={`
relative bg-white w-[92%]  rounded-[10px]
border-[1.3px] flex flex-col
transition-all duration-200
${
  latestAppointment?.visit_confirmation === "Cancelled"
    ? "border-[#E6444C]"
    : data?.quality_risk_metrics
    ? "border-[#800080]"
    : "border-gray-200"
}

  `}
      >
      {latestAppointment?.visit_confirmation === "Cancelled" ? (
          <div className="w-full bg-[#E6444C] text-white text-[12px] font-inter font-medium py-1 text-center rounded-t-[10px]">
            CANCELLED
          </div>
        ) : data?.quality_risk_metrics ? (
          <div className="w-full bg-[#800080] text-white text-[12px] font-inter font-medium py-1 text-center rounded-t-[10px]">
            Risk Adjustments and Quality Measure - Eligible
          </div>
        ) : null
      }

        <div className="relative w-full  gap-4  px-4 py-4 flex ">
          {/* Left Section with Circular Progress */}
          <div className=" flex flex-col justify-between w-[100%] ">
            <div className="flex w-full justify-between">
              <div className="flex justify-center gap-3 items-center">
                <div className="w-[110px] flex items-start flex-col ">
                  <div
                    onClick={() => {
                      if (homescreenprev.includes("P-Card")) {
                        fetchpcarddata(data.id);
                      }
                    }}
                    className="relative flex cursor-pointer justify-center items-center"
                  >
                    <img
                      src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
                      alt="profile"
                      onError={(e) =>
                        (e.target.src =
                          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg==")
                      }
                      className="flex justify-center items-center w-[70px] h-[70px]  border-2 border-[pink] rounded-[14px]  "
                      style={{
                        border: `${3.5}px solid #${data.deductiblemet}`,
                      }}
                    />
                  </div>
                </div>
                <div className="w-full flex justify-start flex-col items-start gap-[2px]">
                  <div className="flex gap-2 items-center ">
                    <div className="text-[#0F172B] font-[500] text-[18px] font-inter">
                      {data.firstname + " " + data.lastname || "-"}
                    </div>
                    <div className="text-[#62748E] font-inter font-normal text-sm tracking-wide">
                      #{data.patientid || "-"}
                    </div>
                  </div>
                  {/* <div className=" flex gap-[5px] items-center">
                    
                  </div> */}

                  <div className="flex flex-col justify-between ">
                    <p className="text-sm font-inter font-normal text-[#62748E] my-0">
                      DOB : {dayjs(dob || data.dob).format("MM/DD/YYYY") || "-"}
                    </p>
                  </div>
                  <div className="flex flex-col justify-between ">
                    <p className="text-sm font-inter font-normal text-[#62748E] my-0">
                      {data.insurancename?.length > 16
                        ? `${data.insurancename.slice(0, 16)}...`
                        : data.insurancename || "-"}
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="flex gap-2 items-center w-[26%]"></div> */}
              <div className="flex items-center justify-between">
                {latestAppointment?.visit_confirmation === "Cancelled" ? (
                  <></>
                ) : (
                  <div
                    onClick={() => {
                      if (homescreenprev.includes("Room Assignment")) {
                        setRoomModalOpen(true);
                      }
                    }}
                    className={` cursor-pointer`}
                  >
                    <RoomBadge roomNo={data?.room_no} />
                  </div>
                )}
              </div>
            </div>
            <div className="grid grid-cols-3 gap-2 w-full">
              <button
                                onClick={(e) => {
                    e.stopPropagation();
                    setPurposeInitialIndex(0);
                    setPurposeModalOpen(true);
                  }}
                className=" flex flex-col items-start text-start bg-[#F8FAFC] rounded-lg py-1.5 px-2 gap-[2px]"
                title="Update Type of Visit"
              >
                {/* Label */}
                <div className="text-[#62748E] w-full font-inter font-normal text-[12px]">
                  Type of Visit
                </div>

                {/* Visits */}
                <div

                  className="text-[#1C398E] w-full flex flex-wrap items-center gap-[2px] font-normal text-[12px] font-inter"
                >
                  {/* First purpose */}
                  <span className="truncate text-[#1E3A8A] inter">
                    {data?.purpose || "-"}
                  </span>

                  {/* Other visits */}
                  {visibleAppts?.slice(1)?.map((appt, index) => (
                    <span
                      key={index}
                      title={appt?.purpose}
                      className="text-[#1E3A8A] truncate"
                    >
                      , {appt?.purpose}
                    </span>
                  ))}

                  {/* More indicator */}
                  {remainingCount > 0 && (
                    <span
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenAllApptsModal(true);
                      }}
                      className="bg-[#EEF2FF] px-2 py-[2px] rounded-[10px] text-[#1D4ED8] font-inter text-[11px] font-medium cursor-pointer"
                    >
                      +{remainingCount} more
                    </span>
                  )}
                </div>
              </button>
              {/* <div
                className=" bg-[#F8FAFC] flex flex-col items-center rounded-lg py-1.5 px-2 gap-[2px]"
                // style={{
                //   backgroundColor:
                //     data?.deductiblemet && data.deductiblemet !== "0"
                //       ? `#${data.deductiblemet.replace("#", "")}99`
                //       : "#F8FAFC"
                // }}
              >
                <div className="text-[#62748E] w-full flex font-inter font-normal text-[12px]">
                  Insurance
                </div>

                <div className="text-[#1C398E] w-full flex font-normal text-[12px] font-inter">
                  {data.insurancename?.length > 16
                    ? `${data.insurancename.slice(0, 16)}...`
                    : data.insurancename || "-"}
                </div>
              </div> */}

              {finalformattedTotalcopay !== null &&
                finalformattedTotalcopay !== undefined && (
                  <div
                    onClick={() => setIsPaymentModalOpen(true)}
                    className="flex flex-col items-start text-start rounded-lg py-1.5 px-2 gap-[2px] cursor-pointer text-white"
                    style={{
                      background: mapColor(data.deductiblemet) || "#E17954",
                    }}
                  >
                    <div className="w-full font-inter font-normal text-[12px]">
                      Amount Due
                    </div>

                    <div className="w-full font-inter font-semibold text-[12px]">
                      ${finalformattedTotalcopay}
                    </div>
                  </div>
                )}

              {data?.quality_risk_metrics !== null &&
                data?.quality_risk_metrics !== undefined && (
                  <div
                    className="flex flex-col items-center rounded-lg p-4 gap-[2px] text-white cursor-pointer hover:opacity-90"
                    style={{ background: "#800080" }}
                    onClick={() => setQuartersModalOpen(true)}
                  >
                    <div className="w-full font-inter text-center font-normal text-[15px]">
                      {data?.quality_risk_metrics}
                    </div>
                    {/* {data?.quality_risk_appts && (
                      // <div className="flex flex-wrap justify-center gap-2 mt-1">
                      //   {["q1","q2","q3","q4"].map((q) =>
                      //     data.quality_risk_appts[q] ? (
                      //       <span key={q} className="bg-white/20 rounded px-2 py-0.5 text-[11px] font-inter">
                      //         Q{q[1]}: {data.quality_risk_appts[q]}
                      //       </span>
                      //     ) : null
                      //   )}
                      // </div>
                    )} */}
                  </div>
                )}

              <QualityRiskApptsModal
                open={quartersModalOpen}
                onClose={() => setQuartersModalOpen(false)}
                patientid={data?.patientid}
                initialDates={data?.quality_risk_appts}
                setToastMessage={setToastMessage}
                setToastSeverity={setToastSeverity}
                setOpenToast={setOpenToast}
                refreshDashboard={refreshDashboard}
              />                
            </div>

            <div className="flex flex-col gap-1 w-full ">
              <div
                className={`bg-[#F9FAFB] rounded-md px-2.5 pt-2.5 pb-4 ${showMore ? "mt-2" : ""} relative`}
              >
                <div className=" flex flex-row items-center justify-between">
                  <div className="font-[400] ml-1 w-full flex font-inter text-xs text-[#62748E] mb-2">
                    Notes
                  </div>

                  <div className="flex flex-row items-center gap-2">
                    <div>
                      {data?.rpm_status !== "Y" ? (
                        <></>
                      ) : (
                        <div>
                          {data?.rpm_status !== "Y" ? null : (
                            <div
                              onClick={() => {
                                if (data?.rpm_status !== "Y") return;
                                navigate(`/rpm?pid=${data?.patientid}`);
                              }}
                              className="bg-[#F0FDF4] text-[#16A34A] text-xs font-inter cursor-pointer flex items-center gap-1 group"
                            >
                              <RpmIcon data={data} latestRpm={latestRpm} />
                              RPM
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                    <div>
                      {" "}
                      {data?.fcmtoken ? (
                        <div className=" bg-[#F2F8FF] cursor-default flex items-center gap-1 font-inter text-xs text-[#055CB4]">
                          {mobileiconnew} APP
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>

                {(() => {
                  const noteItems = [];

                  // 1. Alert / Test(s) due notes
                  // if (data?.notes?.trim()) {
                  //   const cleaned = data.notes
                  //     .replace(/<br\s*\/?>/gi, "")
                  //     .trim();
                  //   const formatted =
                  //     cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
                  //   const isTestsDue = /^Test\(s\)\s*Due:/i.test(formatted);
                  //   const subtitle = isTestsDue
                  //     ? formatted.replace(/^Test\(s\)\s*Due:\s*/i, "")
                  //     : formatted;
                  //   noteItems.push({
                  //     id: "notes",
                  //     title: isTestsDue ? "Test(s) due" : "Notes",
                  //     badge: null,
                  //     subtitle,
                  //     titleColor: "#1D2951",
                  //     subtitleColor: "#1D2951",
                  //   });
                  // }

// Collect all notes from visible appointments
const allNotes = visibleAppts
  ?.filter((appt) => appt?.notes?.trim())
  ?.map((appt) => ({
    note: appt.notes.replace(/<br\s*\/?>/gi, "").trim(),
    starttime: appt.starttime,
  }));

noteItems.push({
  id: "notes",
  title: "Notes",
  subtitle: allNotes,
  titleColor: "#1D2951",
  subtitleColor: "#1D2951",
});

                  // 2. Covered plans
                  const coveredPlans = getCoveredPlans(data);
                  if (coveredPlans.length > 0) {
                    noteItems.push({
                      id: "covered",
                      title: "Covered",
                      badge: null,
                      subtitle: coveredPlans
                        .map(
                          (p) =>
                            p.charAt(0).toUpperCase() +
                            p.slice(1).toLowerCase(),
                        )
                        .join(", "),
                      titleColor: "#111827",
                      subtitleColor: "#6B7280",
                    });
                  }

                  // 3. Cost estimate
                  if (costEstimate > 0 && getPatientColor() !== "green") {
                    noteItems.push({
                      id: "cost",
                      title: "Cost Estimate",
                      badge: null,
                      subtitle: `$${costEstimate}`,
                      titleColor: "#111827",
                      subtitleColor: "#374151",
                    });
                  }

                  // 4. Payment warning
                  if (
                    latestAppointment?.visit_confirmation !== "Cancelled" &&
                    !data?.deductiblemet
                  ) {
                    noteItems.push({
                      id: "payment",
                      title: "Payment",
                      badge: null,
                      subtitle: "Not updated - Contact Gowtham",
                      titleColor: "#1D2951",
                      subtitleColor: "#1D2951",
                    });
                  }

                  if (noteItems.length === 0) return null;

                  const visibleItems = showMore
                    ? noteItems
                    : noteItems.slice(0, 2);
                  const hasMore = noteItems.length > 2;

                  return (
                    <>
                      <div
                        className={showMore ? "overflow-y-auto pr-1" : ""}
                        style={
                          showMore
                            ? {
                                maxHeight: "calc(3 * 52px)",
                                scrollbarWidth: "thin",
                              }
                            : {}
                        }
                      >
                        <div className="flex flex-col gap-2">
                          {visibleItems.map((item) => (
                            <div
                              key={item.id}
                              className="flex items-start gap-2 border-l-2 border-[#1D2951] pl-2"
                            >
                              <div>
                                <div className="flex items-center gap-1.5">
                                  <span
                                    className="text-[13px] font-inter font-semibold"
                                    style={{ color: item.titleColor }}
                                  >
                                    {item.title}
                                  </span>
                                  {item.badge != null && (
                                    <span className="bg-[#EA7840] text-white text-[10px] font-semibold rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center leading-none">
                                      {item.badge}
                                    </span>
                                  )}
                                </div>
                                {/* <p
                                  className="text-[11px] font-inter font-normal mt-0.5 leading-tight"
                                  style={{ color: item.subtitleColor }}
                                >
                                  {item.subtitle}
                                </p> */}
{Array.isArray(item.subtitle) ? (
  item.subtitle.map((entry, idx) => (
    <p
      key={idx}
      className="text-[11px] font-inter font-normal mt-0.5 leading-tight"
      style={{ color: item.subtitleColor, textAlign: "justify" }}
    >
      • {entry.note}
      {item.subtitle.length > 1 && entry.starttime
        ? ` - ${formatTime(entry.starttime)}`
        : ""}
    </p>
  ))
) : (
  <p
    className="text-[11px] font-inter font-normal mt-0.5 leading-tight"
    style={{ color: item.subtitleColor, textAlign: "justify" }}
  >
    {item.subtitle}
  </p>
)}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      {hasMore && (
                        <button
                          onClick={() => setShowMore(!showMore)}
                          className="absolute bottom-1 right-2 text-[12px] font-inter"
                          style={{ color: "#50869A" }}
                        >
                          {showMore ? "Show less" : "Show more"}
                        </button>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
          <div className="w-full flex-col ml-4">
            <div className="flex items-center gap-2 mb-2">
              <div className="bg-[#0F172B] border-[1px] border-[#00000000] px-1.5 py-[2px] rounded-[10px] text-[#FFFFFF] font-inter text-[12px] font-medium">
                {formatTime(latestAppointment?.starttime) || "-"}
              </div>

              {latestAppointment?.visit_confirmation ? (
                <button
                  onClick={() => {
                    if (homescreenprev.includes("Visit Confirmation")) {
                      setVisitModalOpen(true);
                    }
                  }}
                  className={
                    "px-3 py-[2px] font-inter font-medium rounded-[10px] text-[12px] border-[1px] focus:outline-none " +
                    statusChipClasses(
                      latestAppointment?.visit_confirmation,
                      Boolean(latestAppointment?.visit_confirmation),
                    )
                  }
                  title="Update Visit Status"
                >
                  {latestAppointment?.visit_confirmation}
                </button>
              ) : (
                <button
                  onClick={() => {
                    if (homescreenprev.includes("Visit Confirmation")) {
                      setVisitModalOpen(true);
                    }
                  }}
                  className={`px-4 py-[2px] font-inter font-medium rounded-[10px] text-[12px] border-[1px] border-[#ECECEE] text-[#1D4ED8] focus:outline-none`}
                >
                  Visit Status
                </button>
              )}
              <div
                className="cursor-pointer"
                onClick={() => {
                  if (homescreenprev.includes("Change Provider")) {
                    setProviderModalOpen(true);
                  }
                }}
              >
                <div className="text-[#004867] flex gap-1  w-full  items-center font-normal text-[12px] font-inter">
                  {bluesethescope} {latestAppointment?.linked_provider || "-"}
                </div>
              </div>
            </div>

            <div className="w-full flex lg:justify-center">
              <CardBox data={data} paymentdetails={paymentdetails} />
            </div>
          </div>
          <div className="flex w-[10%] justify-center items-center ml-2 pl-4 border-l-[1px] border-[#E5E5E5] flex-col pt-1 gap-2">
            {pinnedActions.map((action) => (
              <div key={action.id} className="relative group">
                <button
                  onClick={action.onClick}
                  className={`${
                    (action.key === "Notes" && noteModalOpen) ||
                    (action.key === "Take Payment" && isPaymentModalOpen)
                      ? "bg-[#1D2951] text-white"
                      : "bg-[#F9FAFB]"
                  } h-[56px] w-[56px] flex justify-center items-center rounded-[12px] cursor-pointer hover:bg-[#1D2951] hover:text-white transition`}
                >
                  {action.icon}
                </button>
                <span className="absolute left-[60px] top-1/2 -translate-y-1/2 bg-[#1D2951] text-white text-xs font-medium py-1.5 px-3 rounded-md opacity-0 group-hover:opacity-100 pointer-events-none transition-all duration-200 whitespace-nowrap shadow-md">
                  {action.label}
                </span>
              </div>
            ))}

            {/* Dropdown for remaining actions */}
            {homescreenprev.includes("Actions") && (
              <div className="flex flex-col cursor-pointer bottom-0 right-0 text-[#F9FAFB] w-[56px] justify-center items-center rounded-[12px]">
                <DropdownMenu
                  homescreenprev={homescreenprev}
                  insertdata={insertdata}
                  viewMode={viewMode}
                  isSameDate={isSameDate}
                  data={data}
                  setToastSeverity={setToastSeverity}
                  setToastMessage={setToastMessage}
                  setOpenToast={setOpenToast}
                  modalopen={modalopen}
                  openPaymentModal={openPaymentModal}
                  openNoteModal={openNoteModal}
                  isOpen={isOpen}
                  searchTerm={searchTerm}
                  setIsOpen={setIsOpen}
                  setSelectedCard={setSelectedCard}
                  setChat={setChat}
                  loc={"exp"}
                  handleschedular={handleschedular}
                />
              </div>
            )}
          </div>

          {/* {imagingmodal?<ImagingModal data={data} setImagingModal={setImagingModal}  imagingmodal={imagingmodal} />:<></>} */}
          {isPaymentModalOpen && (
            <Paymentsmodal
              alldata={alldata}
              setFetchedData={setFetchedData}
              data={data}
              fetchedData={alldata}
              costEstimate={costEstimate}
              closePaymentModal={closePaymentModal}
            />
          )}
          {/* Right Section with Time, Doctor, and Room Info */}
        </div>
      </div>
      {VisitStatus && (
        <VisitStatusUpdate
          selectedAppointment={data}
          closeAllModals={closeVisitStatus}
        />
      )}
      {visitModalOpen ? (
        <VisitStatusModal
          open={visitModalOpen}
          current={latestAppointment?.visit_confirmation || ""}
          onClose={() => setVisitModalOpen(false)}
          selectedCard={data}
          setFetchedData={setFetchedData}
          setVisitModalOpen={setVisitModalOpen}
        />
      ) : (
        <></>
      )}

      {roomModalOpen ? (
        <AssignRoomModal
          setRoomModalOpen={setRoomModalOpen}
          setFetchedData={setFetchedData}
          open={roomModalOpen}
          currentRoom={data.room_no || ""}
          onClose={() => setRoomModalOpen(false)}
          selectedCard={data}
          alldata={alldata}
        />
      ) : (
        <></>
      )}

      {purposeModalOpen && (
        <PurposeOfVisitModal
          open={purposeModalOpen}
          setFetchedData={setFetchedData}
          setPurposeModalOpen={setPurposeModalOpen}
          onClose={() => setPurposeModalOpen(false)}
          selectedCard={data}
          appointments={allAppts}
          formatTime={formatTime}
          initialIndex={purposeInitialIndex}
        />
      )}

      {noteModalOpen && (
        <AddNotesModal
          open={noteModalOpen}
          defaultAssignee={noteDraft.assignee}
          defaultMessage={noteDraft.message}
          setNoteModalOpen={setNoteModalOpen}
          setFetchedData={setFetchedData}
          selectedCard={data}
          refreshDashboard={refreshDashboard}
        />
      )}

      {providerModalOpen && (
        <ProviderModal
          open={providerModalOpen}
          current={localProvider}
          onClose={() => setProviderModalOpen(false)}
          selectedCard={data}
          setFetchedData={setFetchedData}
          setProviderModalOpen={setProviderModalOpen}
        />
      )}
      <AllAppointmentsModal
        statusChipClasses={statusChipClasses}
        open={openAllApptsModal}
        onClose={() => setOpenAllApptsModal(false)}
        appointments={data.allappts}
        formatTime={formatTime}
        onEditPurpose={(index) => {
          setPurposeInitialIndex(index || 0);
          setOpenAllApptsModal(false);
          setPurposeModalOpen(true);
        }}
      />
      {frontdeskModal && (
        <ConfirmFrontdesk
          frontDesk={frontDesk}
          handleFrontDeskToggle={handleFrontDeskToggle}
          setfrontdeskModal={setfrontdeskModal}
        />
      )}
      {isQuickOpen && (
        <TasksModal
          setFetchedData={setFetchedData}
          setToastSeverity={setToastSeverity}
          setToastMessage={setToastMessage}
          setOpenToast={setOpenToast}
          handleconfirmScheduleClick={handleconfirmScheduleClick}
          scheduleStates={scheduleStates}
          closetaskModal={() => {
            setIsQuickOpen(false);
          }}
          handleScheduleClick={handleScheduleClick}
          task={totalOrders}
          markAsComplete={markAsComplete}
          markAscancel={markAscancel}
          data={data}
          // fetchDashboardData={fetchDashboardData}
        />
      )}
    </>
  );
};

export default ExpandedView;
